import VerticalMenu from './vertical-menu';
import BuildingSelectModal from '@/features/building/BuildingSelectModal';
import PlateNumberHistoryModal from '@/features/modals/PlateNumberHistoryModal'
import MobileBottomAppBar from './MobileBottomAppBar';
import ManualPaymentModalStep2 from '@/features/modals/ManualPaymentModalStep2';
import ManualPaymentModalStep1 from '@/features/modals/ManualPaymentModalStep1';
import OpenHistoryModal from '@/features/modals/OpenHistoryModal';
import PlateNumberAddModal from '@/features/modals/PlateNumberAddModal';
import PlateNumberEditModal from '@/features/modals/PlateNumberEditModal';
import EditDebtModal from '@/features/billing/EditDebtModal'
import RemoveDebtModal from '@/features/billing/RemoveDebtModal'
import BulkWriteOffModal from '@/features/billing/BulkWriteOffModal'
import Box from '@mui/material/Box';
import { UpsertModal as AccessUpsertModal } from '@/features/access';
import { AiAssistantFab } from '@/features/ai-assistant';

const Layout = ({ 
  children,
}) => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: {
          xs:'column',
          md:'row',
        },
        minHeight: '100vh',
      }}
    >
      <VerticalMenu />
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          minWidth: 0,
          maxWidth: '100%',
          background: theme.palette.sidebar.mainBg,
        })}
      >
        {children}
      </Box>
      {/* TODO move to modals component and add lazy loading depending on access */}
      <AccessUpsertModal />
      <MobileBottomAppBar />
      <BuildingSelectModal />
      <OpenHistoryModal />
      <PlateNumberHistoryModal />
      <PlateNumberAddModal />
      <PlateNumberEditModal />
      <ManualPaymentModalStep1/>
      <ManualPaymentModalStep2/>
      <RemoveDebtModal />
      <BulkWriteOffModal />
      <EditDebtModal />
      <AiAssistantFab />
    </Box>
  )
}

export default Layout;
